import "./ServiceDetailsCardComponent.scss";
import {ImageConfig} from "../../../constants";

interface TherapyServiceCardComponentProps {
    serviceDetails: any;
    setModalOpen?: any;
}

const ServiceDetailsCardComponent = (props: TherapyServiceCardComponentProps) => {
    const {serviceDetails, setModalOpen} = props;


    return (
        <div className={'therapy-service-card-component '}>
            <div className="therapy-service-and-icon-wrapper">
                <div className="name-logo-avatar">
                    <img src={serviceDetails?.category_details?.image?.url} className="option-icon"
                         alt={ImageConfig.TherapistPlaceholder}/>
                </div>
            </div>

            <div className="therapy-service-wrapper">
                <div className={"therapy-service-card-title"}>{serviceDetails?.category_details?.name}</div>
                <div className="therapy-service-name">{serviceDetails?.service_details?.name}</div>
                <div
                    className="therapy-service-description"
                    dangerouslySetInnerHTML={{__html: serviceDetails?.category_details?.description ? (serviceDetails?.category_details?.description?.length > 30 ? serviceDetails?.category_details?.description.substring(0, 30) + '...' : serviceDetails?.category_details?.description) : 'N/A'}}/>
                <span className={'read-more-link'} onClick={() => setModalOpen(true)}>Read More</span></div>
        </div>
    );

};

export default ServiceDetailsCardComponent;
